// 日期格式化
export function parseTime (time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

//把秒转成时分秒格式
export function formatSeconds (time) {
  console.log(time)
  // 严格检查输入类型和有效性
  if (typeof time !== 'number' || isNaN(time) ||!isFinite(time)) {
    return '00:00:00';
  }

  // 确保时间是非负数
  time = Math.max(0, parseFloat(time));
  time == null ? 0 : parseInt(time)
  const hour = parseInt(time / 3600) < 10 ? '0' + parseInt(time / 3600) : parseInt(time / 3600)
  const min = parseInt(time % 3600 / 60) < 10 ? '0' + parseInt(time % 3600 / 60) : parseInt(time % 3600 / 60)
  const sec = parseInt(time % 3600 % 60) < 10 ? '0' + parseInt(time % 3600 % 60) : parseInt(time % 3600 % 60)
  return hour + ':' + min + ':' + sec
}
export function formatIsoToDateTime(isoStr) {
  if (!isoStr) return '';
  const date = new Date(isoStr);
  if (isNaN(date.getTime())) return '';

  const pad = (n) => n.toString().padStart(2, '0');
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
//把时间戳转成时分秒格式
export function formatTimestamp (value) {
  if (!value) return '';

  // 将输入的值转换为数值类型
  const timestamp = parseInt(value, 10);
  if (isNaN(timestamp)) return '';

  // 将时间戳转换为Date对象
  const date = new Date(timestamp);

  // 获取时分秒
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  // 返回格式化后的时间
  return `${hours}:${minutes}:${seconds}`;
}
export function timestamp (value) {
  if (!value) return '';
  // 将输入的值转换为数值类型
  const timestamp = parseInt(value, 10);
  if (isNaN(timestamp)) return '';

  // 将时间戳转换为Date对象
  const date = new Date(timestamp);

  // 获取时分秒
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

//时间日期框 年-月-日-时-分-秒
export function data (date) {
  if (!(date instanceof Date)) return null;
  let y = date.getFullYear();
  let m = (date.getMonth() + 1).toString().padStart(2, '0');
  let d = date.getDate().toString().padStart(2, '0');
  let HH = date.getHours().toString().padStart(2, '0');
  let mm = date.getMinutes().toString().padStart(2, '0');
  let ss = date.getSeconds().toString().padStart(2, '0');
  return `${y}-${m}-${d} ${HH}:${mm}:${ss}`;
}
//时间日期框 年-月-日
export function dataYmd (date) {
  if (!(date instanceof Date)) return null;
  let y = date.getFullYear();
  let m = (date.getMonth() + 1).toString().padStart(2, '0');
  let d = date.getDate().toString().padStart(2, '0');
  let HH = date.getHours().toString().padStart(2, '0');
  let mm = date.getMinutes().toString().padStart(2, '0');
  let ss = date.getSeconds().toString().padStart(2, '0');
  return `${y}-${m}-${d}`;
}